export enum FilterFlowTypeEnum {
  notApplicable = 'notApplicable',
  tree = 'tree',
  treelist = 'treelist',
  search = 'search',
  continuous = 'continuous',
  continuous_noYearDimension = 'continuous_noYearDimension',
  date = 'date'
}